// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xpTdq{padding:12px 16px;margin:0;list-style:none}@media screen and (min-width:768px){.xpTdq{display:flex;padding:0}}.iYNfT{display:flex;flex:0 0 auto;align-items:center;justify-content:space-between;padding:12px 0}@media screen and (min-width:768px){.iYNfT{display:block;min-width:256px;padding:0 16px 0 0}}.iYNfT .iu\\+I4{margin-left:16px}@media screen and (min-width:768px){.iYNfT .iu\\+I4{margin:9px 0 0 64px}}@media screen and (min-width:768px){.u3QgE.xpTdq{flex-direction:column}.u3QgE .iYNfT{min-width:240px;flex-basis:auto;padding-right:0;margin:0 0 16px}}[data-a11y] .iYNfT{min-width:264px;padding-right:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articleAuthorsList": "xpTdq",
	"author": "iYNfT",
	"button": "iu+I4",
	"tooltip": "u3QgE"
};
module.exports = ___CSS_LOADER_EXPORT___;
